<template>
  <router-view></router-view>
</template>

<script>
// import createFCMToken from "@/firebase/getUserToken"

export default {
  name: 'App',
  mounted(){
    // createFCMToken()
  }
 
}
</script>

<style>
.pagination{
  margin-bottom: 0px ;
  margin-top: 0px
}
</style>
